<section>
  <div class="content-2">
    <div class="title-container">
      <h1 class="title">Tamanho das turmas</h1>
      <h2 class="subtitle">
        Informe o número de alunos por turma em cada etapa/modalidade.
      </h2>
    </div>

    <hr class="division-line" />

    <div class="dropdown-panel panel">
      <app-menu-suspenso
        #menuTooltip="matTooltip"
        [matTooltip]="menuTooltipVisible ? 'Visualizar o PQR' : ''"
        matTooltipPosition="above"
        [opcoes]="[
          {
            rotulo: 'PQR desta funcionalidade',
            icone: 'computer',
            acao: 'pqrDestaFuncionalidade'
          },
          {
            rotulo: 'Restaurar valores com base no PQR',
            icone: 'content_copy',
            acao: 'restaurarValoresComBaseNoPqr'
          },
          {
            rotulo: 'PQR completo em nova aba',
            icone: 'desktop_windows',
            acao: 'pqrCompletoEmNovaAba'
          }
        ]"
        (chamadaDeAcao)="chamarAcao($event)"
      >
        Padrão de qualidade de referência (PQR)
      </app-menu-suspenso>

      <mat-icon
        (mouseenter)="openTooltips()"
        (mouseleave)="closeTooltips()"
        class="info-icon"
        #infoTooltip="matTooltip"
        matTooltip="Informações sobre o PQR"
        matTooltipPosition="left"
      >
        info
      </mat-icon>
    </div>

    <div class="panel" *ngIf="featureFlagService.funcionalidadeHabilitada('1108-pqr-minimo-turma') && featureFlagService.funcionalidadeHabilitada('1104-creche-idade'); else gridsAntigas">
      <div class="table-wrapper">
        <app-tabela
          ngSkipHydration
          class="table-component"
          [cabecalhoCustomizado]="true"
        >
          <ng-container cabecalho>
            <tr>
              <th
                class="table-header"
                rowspan="3"
                colspan="5"
                style="width: 35%"
              >
                Etapa / Segmento / Modalidade
              </th>
              <th
                class="table-header"
                rowspan="1"
                colspan="5"
                style="width: 25%; text-align: center !important;"
              >
                Escolas URBANAS
              </th>
              <th
                class="table-header"
                rowspan="1"
                colspan="5"
                style="width: 25%"
              >
                Escolas de áreas RURAIS

              </th>
              <th
                class="table-header"
                rowspan="2"
                colspan="5"
                style="width: 25%"
              >
                Critério para criação de turmas

              </th>
            </tr>
            <tr>
              <th
                class="table-header"
                rowspan="1"
                colspan="4"
                style="width: 20%"
              >
                Alunos por turma
              </th>
              <th
                class="table-header"
                rowspan="2"
                colspan="1"
                style="width: 5%"
              >
                Docentes por turma
              </th>
              <th
                class="table-header"
                rowspan="1"
                colspan="4"
                style="width: 20%"
              >
                Alunos por turma
              </th>
              <th
                class="table-header"
                rowspan="2"
                colspan="1"
                style="width: 5%"
              >
                Docentes por turma
              </th>
            </tr>
            <tr>
              <th class="table-header" rowspan="1" colspan="2">Diagnóstico {{anoCenso}} <sup>(1) (2)</sup></th>
              <th class="table-header" rowspan="1 " colspan="2">Número Máximo</th>
              <th class="table-header" rowspan="1" colspan="2">Diagnóstico {{anoCenso}} <sup>(1) (2)</sup></th>
              <th class="table-header" rowspan="1 " colspan="2">Número Máximo</th>
              <th class="table-header" rowspan="1 " colspan="2">Número mínimo de turmas</th>
              <th class="table-header" rowspan="1 " colspan="2">Número mínimo de matrículas para abrir o número mínimo de turmas</th>
            </tr>
          </ng-container>
          <ng-container corpo>
            <tr *ngFor="let dados of dadosTabelaUrbana; let i = index;">
              <td class="table-cell align-left" colspan="5">
                {{ dados.etapa.descricao }}
              </td>
              <td class="table-cell align-center text-blue" colspan="2"
                  *ngIf="!ehCrecheSegregadaOculta(dados)"
                  [attr.rowspan]="ehPrimeiraCrecheSegregada(dados) ? 4 : 1">
                <ng-container *ngIf="dados.mediaAlunos !== null">
                  {{ dados.mediaAlunos }}
                </ng-container>
              </td>
              <td class="table-cell align-center" colspan="2">
                <input
                  type="number"
                  [(ngModel)]="dados.numAlunos"
                  (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                  class="display-input text-green"
                  maxlength="2"
                  appOnlyNumbers
                  style="display: inherit !important;"
                />
              </td>
              <td class="table-cell align-center" colspan="1">
                <input
                  type="number"
                  [(ngModel)]="dados.numDocentes"
                  (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                  class="display-input text-green"
                  maxlength="2"
                  appOnlyNumbers
                  style="display: inherit !important;"
                />
              </td>
              <td class="table-cell align-center text-blue" colspan="2"
                  *ngIf="!ehCrecheSegregadaOculta(dadosTabelaRural[i])"
                  [attr.rowspan]="ehPrimeiraCrecheSegregada(dadosTabelaRural[i]) ? 4 : 1">
                <ng-container *ngIf="dadosTabelaRural[i].mediaAlunos !== null">
                  {{ dadosTabelaRural[i].mediaAlunos }}
                </ng-container>
              </td>
              <td class="table-cell align-center" colspan="2">
                <input
                  type="number"
                  [ngModel]="dadosTabelaRural[i].numAlunos"
                  (ngModelChange)="dadosTabelaRural[i].numAlunos = $event; atualizarDadosDoServicoDeEstado()"
                  class="display-input text-green"
                  maxlength="2"
                  appOnlyNumbers
                  style="display: inherit !important;"
                />
              </td>
              <td class="table-cell align-center" colspan="1">
                <input
                  type="number"
                  [ngModel]="dadosTabelaRural[i].numDocentes"
                  (ngModelChange)="dadosTabelaRural[i].numDocentes = $event; atualizarDadosDoServicoDeEstado()"
                  class="display-input text-green"
                  maxlength="2"
                  appOnlyNumbers
                  style="display: inherit !important;"
                />
              </td>
              <td class="table-cell align-center" colspan="2">
                <input
                  type="number"
                  [(ngModel)]="dados.minimoTurmas"
                  (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                  class="display-input text-green"
                  maxlength="2"
                  appOnlyNumbers
                  style="display: inherit !important;"
                />
              </td>
              <td class="table-cell align-center" colspan="2">
                <input
                  type="number"
                  [(ngModel)]="dados.minimoMatriculasPorTurma"
                  (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                  class="display-input text-green"
                  maxlength="2"
                  appOnlyNumbers
                  style="display: inherit !important;"
                />
              </td>
            </tr>
          </ng-container>
        </app-tabela>
        <app-rodape-fonte-nota [foteNota]="notasFonte"> </app-rodape-fonte-nota>
      </div>
    </div>

    <ng-template #gridsAntigas>
      <div class="panel">
        <div class="table-wrapper">
          <app-tabela
            ngSkipHydration
            class="table-component"
            [cabecalhoCustomizado]="true"
          >
            <ng-container cabecalho>
              <tr>
                <th
                  class="table-header"
                  rowspan="3"
                  colspan="5"
                  style="width: 50%"
                >
                  Etapa / Modalidade
                </th>
                <th
                  class="table-header"
                  rowspan="1"
                  colspan="5"
                  style="width: 50%"
                >
                  Escolas URBANAS
                </th>
              </tr>
              <tr>
                <th
                  class="table-header"
                  rowspan="1"
                  colspan="4"
                  style="width: 30%"
                >
                  Alunos por turma
                </th>
                <th
                  class="table-header"
                  rowspan="2"
                  colspan="1"
                  style="width: 70%"
                >
                  Docentes por turma
                </th>
              </tr>
              <tr>
                <th class="table-header" rowspan="1" colspan="2">Diagnóstico {{anoCenso}} <sup>(1) (2)</sup></th>
                <th class="table-header" rowspan="1 " colspan="2">Número Máximo</th>
              </tr>
            </ng-container>
            <ng-container corpo>
              <tr *ngFor="let dados of dadosTabelaUrbana; let i = index;">
                <td class="table-cell align-left" colspan="5">
                  {{ dados.etapa.descricao }}
                </td>
                <td class="table-cell align-center text-blue" colspan="2">
                  <ng-container *ngIf="dados.mediaAlunos !== null">
                    {{ dados.mediaAlunos }}
                  </ng-container>
                </td>
                <td class="table-cell align-center" colspan="2">
                  <input
                    type="number"
                    [(ngModel)]="dados.numAlunos"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                    class="display-input text-green"
                    maxlength="2"
                    appOnlyNumbers
                    style="display: inherit !important;"
                  />
                </td>
                <td class="table-cell align-center" colspan="1">
                  <input
                    type="number"
                    [(ngModel)]="dados.numDocentes"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                    class="display-input text-green"
                    maxlength="2"
                    appOnlyNumbers
                    style="display: inherit !important;"
                  />
                </td>
              </tr>
            </ng-container>
          </app-tabela>
          <app-rodape-fonte-nota [foteNota]="notasFonte"> </app-rodape-fonte-nota>
        </div>
      </div>
      <div class="panel mt-8">
        <div class="table-wrapper">
          <app-tabela ngSkipHydration class="table-component" [cabecalhoCustomizado]="true">
            <ng-container cabecalho>
              <tr>
                <th class="table-header" rowspan="3" colspan="5" style="width: 50%">
                  Etapa / Modalidade
                </th>
                <th class="table-header" rowspan="1" colspan="5" style="width: 50%">
                  Escolas de áreas RURAIS
                </th>
              </tr>
              <tr>
                <th class="table-header" rowspan="1" colspan="4" style="width: 30%">
                  Alunos por turma
                </th>
                <th class="table-header" rowspan="2" colspan="1" style="width: 70%">
                  Docentes por turma
                </th>
              </tr>
              <tr>
                <th class="table-header" rowspan="1" colspan="2">Diagnóstico {{anoCenso}} <sup>(1) (2)</sup></th>
                <th class="table-header" rowspan="1" colspan="2">Número Máximo</th>
              </tr>
            </ng-container>

            <ng-container corpo>
              <tr *ngFor="let dados of dadosTabelaRural; let i = index;">
                <td class="table-cell align-left" colspan="5">
                  {{ dados.etapa.descricao }}
                </td>

                <td class="table-cell align-center text-blue" colspan="2">
                  <ng-container *ngIf="dados.mediaAlunos !== null">
                    {{ dados.mediaAlunos }}
                  </ng-container>
                </td>

                <td class="table-cell align-center" colspan="2">
                  <input
                    type="number"
                    [(ngModel)]="dados.numAlunos"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                    class="display-input text-green"
                    maxlength="2"
                    appOnlyNumbers
                    style="display: inherit !important;"
                  />
                </td>

                <td class="table-cell align-center" colspan="1">
                  <input
                    type="number"
                    [(ngModel)]="dados.numDocentes"
                    (ngModelChange)="atualizarDadosDoServicoDeEstado()"
                    class="display-input text-green"
                    maxlength="2"
                    appOnlyNumbers
                    style="display: inherit !important;"
                  />
                </td>
              </tr>
            </ng-container>
          </app-tabela>

          <app-rodape-fonte-nota [foteNota]="notasFonte"></app-rodape-fonte-nota>
        </div>
      </div>
    </ng-template>
  </div>
</section>
